import { jsxs as u, jsx as e } from "react/jsx-runtime";
import "react";
function f({
  fullSizeUrl: r,
  sources: a = [{ srcsets: [""], media: "" }],
  altText: i = "",
  classname: t = "",
  handleClick: c = () => !0,
  loading: m = "lazy",
  // null/'eager', 'lazy'
  decoding: n = "async",
  // 'sync', 'async', 'auto'
  fetchpriority: o = null
  // null/'low', 'high'
}) {
  return /* @__PURE__ */ u("picture", { className: t, children: [
    a.map((s, l) => /* @__PURE__ */ e("source", { media: `(${s.media})`, srcSet: s.srcsets.join(", ") }, `source-${l}`)),
    /* @__PURE__ */ e(
      "img",
      {
        src: r,
        alt: i,
        onClick: c,
        loading: m,
        decoding: n,
        fetchpriority: o
      }
    )
  ] });
}
export {
  f as ResponsiveImage,
  f as default
};
